<!-- 折线图 -->
<template>
  <div class="h-line">
    <ve-line
      :data="chartData"
      :settings="chartSettings"
      height="250px"
      width="348px"
      :extend="chartExtend"
    ></ve-line>
  </div>
</template>

<script>
export default {
  data () {
    this.chartSettings = {
      metrics: ['新增门店'],
      dimension: ['日期'],
      scale: [true, true]
    }
    return {
      chartExtend: {
        series: {
          label: {
            normal: {
              show: true,
              color: '#90E23C',
              fontSize: 18
            }
          },
          symbolSize: 10,
          color: ['#44F0FF']
        },
        legend: {
          show: false
        },
        grid: {
          left: 10,
          top: 30,
          containLabel: true
        },
        xAxis: {
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: 14
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#fff'
            }
          }
        },
        yAxis: {
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: 14
            }
          },
          splitLine: {
            show: false
          },
          position: 'left',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#fff'
            }
          },
          min: function (value) {
            return value.min
          }
        }
      }
    }
  },

  props: {
    chartData: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang='stylus' scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/hLine.vue